import React from "react"

export default function TypeHidden(props) {
  const { fieldname, label } = props
  return (
    <div style={{ display: "none" }} id={fieldname}>
      {label}
    </div>
  )
}
